module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAARCAYAAACSGY9uAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAArSURBVEhL7c8BDQAwEAOh+Tfd2SCfwwFvxxTSFdIV0hXSFdIV0hXSFbJtH7RqwvTxYrlGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/15.jpg
// module id = qoG4
// module chunks = 1